export default {
  setHeaderLayout({ commit }, name) {
    localStorage.setItem('_header_layout_name', name)
    commit('SET_HEADER_LAYOUT', name)
  },

  setNavbarOpen({ commit }, status) {
    commit('SET_NAVBAR_OPEN', status)
  },
  // Topかどうか知る
  isTop({ commit }, status) {
    commit('SET_ISTOP', status)
  },
  // 200pxスクロール
  getScroll200({ commit }, status) {
    commit('updateScroll200', status)
  },
  setStoreLoading({ commit }, boolean) {
    // const self = this;
    commit('updateStoreLoading', boolean)
  },
}
